import { create } from 'zustand'

interface Toast {
  id: string
  title: string
  description?: string
  type: 'success' | 'error' | 'warning' | 'info'
}

interface ConfirmDialog {
  isOpen: boolean
  title: string
  description: string
  confirmLabel: string
  cancelLabel: string
  onConfirm: () => void | Promise<void>
  onCancel?: () => void
  variant?: 'default' | 'destructive'
}

const INITIAL_STATE = {
  toasts: [] as Toast[],
  confirmDialog: null as ConfirmDialog | null,
  isGlobalLoading: false,
}

interface UIStore {
  toasts: Toast[]
  confirmDialog: ConfirmDialog | null
  isGlobalLoading: boolean
  addToast: (toast: Omit<Toast, 'id'>) => void
  removeToast: (id: string) => void
  clearToasts: () => void
  showConfirm: (options: Omit<ConfirmDialog, 'isOpen'>) => void
  hideConfirm: () => void
  setGlobalLoading: (loading: boolean) => void
  reset: () => void
}

export const useUIStore = create<UIStore>((set) => ({
  ...INITIAL_STATE,

  addToast: (toast) =>
    set((state) => ({
      toasts: [...state.toasts, { ...toast, id: crypto.randomUUID() }],
    })),

  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),

  clearToasts: () => set({ toasts: [] }),

  showConfirm: (options) =>
    set({
      confirmDialog: { ...options, isOpen: true },
    }),

  hideConfirm: () => set({ confirmDialog: null }),

  setGlobalLoading: (loading) => set({ isGlobalLoading: loading }),

  reset: () => set(INITIAL_STATE),
}))
